import { getDeviceInfo } from '@moniebook-web/utils';
import { Axios, REGISTERS_API_URL } from '@register-ui/utils';
import { useEffect, useState } from 'react';

type DownloadLinksResponse = {
    [key in 'android' | 'ios']: { url: string };
};

export function useAppDownloadLinks() {
    const [link, setLink] = useState('');

    const fetchVersion = async () => {
        const { data } = await Axios.get<DownloadLinksResponse>(
            REGISTERS_API_URL.REGISTER.DOWNLOAD_URLS,
        );

        if (data) {
            const { manufacturer } = getDeviceInfo();

            const url =
                manufacturer === 'iOS' ? data?.ios.url : data?.android.url;
            setLink(url ?? '');
        }
    };

    useEffect(() => {
        fetchVersion();
    }, []);

    return { link };
}
